module.exports = __webpack_public_path__ + "static/media/psd2.ab7be956.gif";